module.exports = __webpack_public_path__ + "static/media/20170806_01day_0012AT.b14a90dc.jpg";